'use client';

import { usePathname } from 'next/navigation';

import { BREAKPOINTS, DONATION_ROUTES } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';

import { FooterMobile } from './_components/FooterMobile';
import { FooterPc } from './_components/FooterPc';

export const Footer = () => {
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const pathname = usePathname();

  //* 초기 작업 히스토리: 답례품 목록에서 장바구니 Bottom CTA 로 인해 푸터 섹션이 가려짐
  const className = (() => {
    switch (pathname) {
      case DONATION_ROUTES.GIFTS.pathname:
        return {
          pc: 'pb-100',
          mobile: 'pb-150',
        };
      default:
        return {
          pc: '',
          mobile: '',
        };
    }
  })();

  return isDesktopViewport ? (
    <FooterPc className={className.pc} />
  ) : (
    <FooterMobile className={className.mobile} />
  );
};
